var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('hero',{attrs:{"heading":_vm.heading}},[_c('div',{staticClass:"mt-6"},[_c('app-button',{attrs:{"router-link":"/"}},[_vm._v("Go Home, Steve")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }